import { MaterialMasterPage } from "./material-master-page"

export default function ItemsPage() {
  return (
    <MaterialMasterPage
      config={{
        title: "Items",
        endpoint: "items",
        resource: "MaterialItem",
        primaryLabel: "item_name",
        columns: [
          { key: "item_code", label: "Code" },
          { key: "item_name", label: "Name" },
          { key: "classification_category.name", label: "Category" },
          { key: "classification_sub_category.name", label: "Sub Category" },
          { key: "unit.name", label: "Unit" },
          { key: "cost_category.name", label: "Cost Category" },
          { key: "billable", label: "Billable" },
          { key: "is_active", label: "Active" },
        ],
        fields: [
          { name: "item_name", label: "Item Name", type: "text" },
          { name: "description", label: "Description", type: "textarea" },
          { name: "classification_category_id", label: "Classification Category", type: "select-search", optionsEndpoint: "classification-categories", optionLabelKey: "name", displayField: "classification_category" },
          { name: "classification_sub_category_id", label: "Sub Category", type: "select-search", optionsEndpoint: "classification-subcategories", optionLabelKey: "name", displayField: "classification_sub_category" },
          { name: "unit_id", label: "Unit", type: "select-search", optionsEndpoint: "units", optionLabelKey: "name", displayField: "unit" },
          { name: "cost_category_id", label: "Cost Category", type: "select-search", optionsEndpoint: "cost-categories", optionLabelKey: "name", displayField: "cost_category" },
          { name: "billable", label: "Billable", type: "checkbox" },
          { name: "default_purchase_rate", label: "Default Purchase Rate", type: "number" },
          { name: "default_selling_rate", label: "Default Selling Rate", type: "number" },
          { name: "min_stock", label: "Min Stock", type: "number" },
          { name: "max_stock", label: "Max Stock", type: "number" },
          { name: "hsn_code", label: "HSN Code", type: "text" },
          { name: "is_active", label: "Active", type: "checkbox" },
        ],
      }}
    />
  )
}
